import { Column, Id } from "@dgs/core";
import { FC } from "react";
import styled from "styled-components";
import { FeedbackEvaluationResource } from "../types/feedback";
import { CompactFeedbackQuestionEvaluation } from "./CompactFeedbackQuestionEvaluation";

const FeedbackName = styled.span`
	font-size: ${({ theme }) => theme.fonts.sizes.large};
	font-weight: ${({ theme }) => theme.fonts.weights.bold};
`;

interface Props {
	eventId: Id;
	feedback: FeedbackEvaluationResource;
}
export const FeedbackEvaluation: FC<Props> = ({ eventId, feedback }) => {
	return (
		<Column $rowGap={5}>
			<FeedbackName>{feedback.feedback.name}</FeedbackName>
			{feedback.questions.map((question) => (
				<CompactFeedbackQuestionEvaluation key={question.id} eventId={eventId} question={question} />
			))}
		</Column>
	);
};
